import { render, staticRenderFns } from "./IdentificationSelector.vue?vue&type=template&id=467a7623"
import script from "./IdentificationSelector.vue?vue&type=script&lang=js"
export * from "./IdentificationSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports